export default __webpack_public_path__ + "static/media/liquidus_logo_round.f72f345a.png";